import React from "react";

const Header = ({titulo}) => (
          <h1>{ titulo }</h1>
);


export default Header;